import classNames from 'classnames';
import type * as React from 'react';
import type { ButtonProps } from '../../Button';
import Button from '../../Button';
import SaveButton from '../../SaveButton';
import styles from './style.m.less';

export const SIZES_CLASSMAP = {
    DEFAULT: styles.default,
    SMALL: styles.small,
    TITLE: styles.title,
} as const;

export type InputButtonSize = keyof typeof SIZES_CLASSMAP;

type Props = {
    size?: InputButtonSize;
};

export const InputButton = ({ className, size = 'DEFAULT', ...otherProps }: Props & ButtonProps) => (
    <Button
        isSmall={size !== 'SMALL'}
        className={classNames(styles.inputButton, SIZES_CLASSMAP[size], className)}
        {...otherProps}
    />
);

export const InputButtonIcon = ({ className, size = 'DEFAULT', ...otherProps }: Props & ButtonProps) => (
    <Button
        kind="PLAIN"
        className={classNames(styles.inputButtonIcon, SIZES_CLASSMAP[size], className)}
        {...otherProps}
    />
);

export const InputSaveButton = ({
    className,
    size = 'DEFAULT',
    ...otherProps
}: Props & React.ComponentPropsWithoutRef<typeof SaveButton>) => (
    <SaveButton
        isSmall={size !== 'SMALL'}
        className={classNames(styles.inputButton, SIZES_CLASSMAP[size], className)}
        {...otherProps}
    />
);
